export const canAccess = (user, permission) => {
    return user?.role?.[permission] === true;
};
